import { CameraConfig } from "../../visuals/ModelBasedVisual";
import { BaseAgent } from "./agents/BaseAgent";
import { BaseService } from "./BaseService";
import * as THREE from "three";

export interface FPVCamera {
  object: THREE.Object3D;
  div: HTMLDivElement;
  camera: THREE.Camera;
  renderer: THREE.WebGLRenderer;
  scene: THREE.Scene;
  agent: BaseAgent;
  isHidden?: boolean;
}

export class FpvCameraService extends BaseService {

  public fpvCameras: FPVCamera[] = [];
  render(delta: number): void {
    // throw new Error("Method not implemented.");
    for (const fpvCamera of this.fpvCameras) {
      if (!fpvCamera.isHidden) {
        fpvCamera.renderer.render(fpvCamera.scene, fpvCamera.camera);
      }
    }
  }

  public addFPVCamera(actor: BaseAgent, div: HTMLDivElement, config: CameraConfig) {
    // console.log("Adding FPV Camera");
    const fov = config.fov || 60; // Default to 60 degrees if not specified
    const camera = new THREE.PerspectiveCamera(fov, div.clientWidth / div.clientHeight, 0.1, 200000);
    const parent = config.parent || actor.visual.obj;
    // const camera = new THREE.OrthographicCamera();
    parent.add(camera);
    camera.position.set(config.position.x, config.position.y, config.position.z);
    camera.rotation.set(config.rotation.x, config.rotation.y, config.rotation.z);
    // camera.rotation.y = -Math.PI / 2;
    // camera.rotation.x = Math.PI / 2;
    // camera.lookAt(config.lookAt);
    // camera.up.set(0, 0, 1);
    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(div.clientWidth, div.clientHeight);
    renderer.shadowMap.enabled = true;

    div.appendChild(renderer.domElement);
    const fpvCamera: FPVCamera = { 
      agent: actor, 
      object: actor.visual.obj, 
      div, camera, renderer, scene: this.worldRenderer.scene };
    this.fpvCameras.push(fpvCamera);
    return fpvCamera;
  }

  public removeFPVCamera(fpvCamera: FPVCamera) {
    const idx = this.fpvCameras.indexOf(fpvCamera);
    if (idx > -1) {
      const fpv = this.fpvCameras[idx];
      // Stop rendering and dispose of the renderer
      fpv.renderer.domElement.remove(); // Remove from DOM (alternative to div.removeChild)
      fpv.renderer.dispose(); // Dispose of WebGL resources
      fpv.renderer.forceContextLoss(); // Ensure WebGL context is fully released (optional, aggressive cleanup)
      // Remove camera from scene graph
      const parent = fpv.camera.parent;
      if (parent) {
        parent.remove(fpv.camera);
      }
      fpv.camera.clear();
      this.fpvCameras.splice(idx, 1);
    }
    console.log("Removed FPV Camera");
  }

}